var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddresses = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 27,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.56 10.78c0 5.402-9.78 14.671-9.78 14.671S1 16.182 1 10.781C1 5.378 5.379 1 10.78 1c5.402 0 9.78 4.379 9.78 9.78"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#202124",
  d: "M10.78 12.003a1.222 1.222 0 1 0 0-2.445 1.222 1.222 0 0 0 0 2.445"
})));
export default SvgAddresses;